
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.875 5.625H3.125a.625.625 0 00-.625.625v10c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625v-10a.625.625 0 00-.625-.625z","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.875 5.625H3.125a.625.625 0 00-.625.625v10c0 .345.28.625.625.625h13.75c.345 0 .625-.28.625-.625v-10a.625.625 0 00-.625-.625zM13.125 5.625v-1.25a1.25 1.25 0 00-1.25-1.25h-3.75a1.25 1.25 0 00-1.25 1.25v1.25","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.5 9.867a14.946 14.946 0 01-7.5 2.008 14.866 14.866 0 01-7.5-2.008M9.063 9.375h1.874","stroke":"#000","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    